import { AddTask, Sort } from "@mui/icons-material";
import { Box, Button, IconButton, Tab, Tabs, Tooltip } from "@mui/material";

import { type TaskFilter } from "../taskUtils";

const tOpen = "Open";
const tCompleted = "Completed";
const tAll = "All";
const tSortOldest = "Sort by oldest first";
const tSortNewest = "Sort by newest first";
const tAddTask = "Add Task";

export interface TaskHeaderProps {
  filter: TaskFilter;
  onFilterChange: (filter: TaskFilter) => void;
  onAddTask?: () => void;
  onSortChange?: () => void;
  showSortButton?: boolean;
  sortNewestFirst?: boolean;
}

export const TaskHeader = ({
  filter,
  onFilterChange,
  onAddTask,
  onSortChange,
  showSortButton = false,
  sortNewestFirst = false,
}: TaskHeaderProps) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center" gap={2}>
        <Tabs value={filter} onChange={(_, newValue) => onFilterChange(newValue as TaskFilter)}>
          <Tab label={tOpen} value="open" />
          <Tab label={tCompleted} value="completed" />
          <Tab label={tAll} value="all" />
        </Tabs>
        {showSortButton && onSortChange && (
          <Tooltip title={sortNewestFirst ? tSortOldest : tSortNewest}>
            <IconButton
              size="small"
              color={sortNewestFirst ? "primary" : "default"}
              onClick={onSortChange}
              aria-label={sortNewestFirst ? tSortOldest : tSortNewest}
            >
              <Sort />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {onAddTask && (
        <Button variant="outlined" size="small" startIcon={<AddTask />} onClick={onAddTask}>
          {tAddTask}
        </Button>
      )}
    </Box>
  );
};
